var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBluenotifiction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#163E6E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.7996 31.2188H11.1996C10.3996 31.2188 9.69956 30.8312 9.29956 30.1531C8.89956 29.475 8.99956 28.7 9.39956 28.0219L10.4996 26.375C12.2996 23.7594 13.1996 20.7563 13.1996 17.6562C13.1996 14.0719 15.5996 10.7781 19.0996 9.61563C19.6996 8.55 20.7996 7.96875 21.9996 7.96875C23.1996 7.96875 24.2996 8.55 24.8996 9.61563C28.3996 10.7781 30.7996 14.0719 30.7996 17.6562C30.7996 20.7563 31.6996 23.7594 33.4996 26.375L34.5996 28.0219C34.9996 28.7 35.0996 29.475 34.6996 30.1531C34.3996 30.8312 33.5996 31.2188 32.7996 31.2188Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0996 33.1562C17.5996 35.3844 19.5996 37.0312 21.9996 37.0312C24.3996 37.0312 26.3996 35.3844 26.8996 33.1562H17.0996Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 13.7812C33 16.9445 30.3439 19.5625 27 19.5625C23.6561 19.5625 21 16.9445 21 13.7812C21 10.618 23.6561 8 27 8C30.3439 8 33 10.618 33 13.7812Z",
    fill: "white",
    stroke: "#163E6E",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.661 12.4295H26.204V14.0255C26.3113 13.8762 26.47 13.7548 26.68 13.6615C26.89 13.5635 27.1163 13.5145 27.359 13.5145C27.7463 13.5145 28.0613 13.5962 28.304 13.7595C28.5467 13.9182 28.7193 14.1258 28.822 14.3825C28.9293 14.6345 28.983 14.9028 28.983 15.1875C28.983 15.5235 28.92 15.8245 28.794 16.0905C28.668 16.3565 28.4743 16.5665 28.213 16.7205C27.9563 16.8745 27.6367 16.9515 27.254 16.9515C26.764 16.9515 26.3673 16.8255 26.064 16.5735C25.7607 16.3215 25.5763 15.9855 25.511 15.5655H26.134C26.1947 15.8315 26.323 16.0392 26.519 16.1885C26.715 16.3378 26.9623 16.4125 27.261 16.4125C27.6297 16.4125 27.9073 16.3028 28.094 16.0835C28.2807 15.8595 28.374 15.5655 28.374 15.2015C28.374 14.8375 28.2807 14.5575 28.094 14.3615C27.9073 14.1608 27.632 14.0605 27.268 14.0605C27.0207 14.0605 26.8037 14.1212 26.617 14.2425C26.435 14.3592 26.302 14.5202 26.218 14.7255H25.616V11.8695H28.661V12.4295Z",
    fill: "#163E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluenotifiction);
export default __webpack_public_path__ + "static/media/bluenotifiction.ccf24ddc7595272b822e1271e78da4af.svg";
export { ForwardRef as ReactComponent };